export default ({ store }, moduleName, moduleStore) => {
    if (!moduleStore) return;

    if (typeof moduleStore === 'function') return moduleStore(store);

    store.registerModule(moduleName, moduleStore);
};
